import { differenceInCalendarDays, format } from 'date-fns';

// Compact sidebar timestamp: the /chat-v2 conversation list is a narrow
// column, so "Wednesday, 22nd July" ate the worker's name. Today → time,
// yesterday → "Yesterday", within a week → weekday, else "22 Jul"
// (+ year when not this year).
export function compactDateLabel(iso: string, now: Date = new Date()): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const daysAgo = differenceInCalendarDays(now, date);
  if (daysAgo <= 0) return format(date, 'h:mm a');
  if (daysAgo === 1) return 'Yesterday';
  if (daysAgo < 7) return format(date, 'EEE');
  if (date.getFullYear() === now.getFullYear()) return format(date, 'd MMM');
  return format(date, 'd MMM yyyy');
}
